import { appRoutes } from "./constants";

export function getAdminChildRoute(nestedRoute: string): string {
    const expectedPrefix = `${appRoutes.OPERATOR_ADMIN}/`;
    if (!nestedRoute.startsWith(expectedPrefix)) { 
        return nestedRoute;
    }
    return nestedRoute.slice(expectedPrefix.length);
}